import React, { useState, useRef, useEffect } from 'react';
import { Check, X } from 'lucide-react';

interface TagInputProps {
  onAdd: (tag: string) => void;
  onCancel: () => void;
}

const TagInput: React.FC<TagInputProps> = ({ onAdd, onCancel }) => {
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = () => {
    const trimmedValue = value.trim();
    if (trimmedValue) {
      onAdd(trimmedValue);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSubmit();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div className="inline-flex items-center gap-1 px-2 py-1 bg-white border border-gray-300 rounded-full text-sm">
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyPress={handleKeyPress}
        onBlur={onCancel}
        placeholder="Tag name"
        className="bg-transparent border-none outline-none min-w-0 w-20"
      />
      <button
        onClick={handleSubmit}
        className="p-0.5 text-green-600 hover:bg-green-100 rounded-full"
      >
        <Check className="w-3 h-3" />
      </button>
      <button
        onClick={onCancel}
        className="p-0.5 text-red-600 hover:bg-red-100 rounded-full"
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  );
};

export default TagInput;